import React from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import { useFetchList } from 'store'

import styles from './ContextualController.module.sass'
import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
import { Link, useParams } from 'react-router-dom'

const CompanyRow = (props) => {
	const { data, ...attributes } = props
	return (
		<div {...attributes} className={styles['row']}>
			<h5>{data?.insuranceCompanyId}</h5>
			<Link
				className={styles['large']}
				to={{
					search: `?company=${data?.insuranceCompanyId}`,
				}}
			>
				<small>{data?.total || 0}</small>
			</Link>
		</div>
	)
}

const ContextualUserController = () => {
	const { i18n } = useGlobal()
	const params = useParams()

	const statsUri = `users/${params?.userId}/task_stats/`
	const {
		contents: [statsData],
	} = useFetchList([statsUri])
	return (
		<>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`By Ins. Company`}
				expanded={statsData ? true : false}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<Widget className={styles['aside-widget-content']}>
					<div className={styles['list-header']}>
						<h5>&nbsp;</h5>
						<small>{i18n`No. Tasks`}</small>
					</div>
					<Collection
						itemsHeight={28}
						card={CompanyRow}
						items={statsData}
					/>
				</Widget>
			</ExpandableWidget>
		</>
	)
}

export default ContextualUserController
